module.exports = __webpack_public_path__ + "static/1-7ce01e57215843ce4b070af99e7b0624.jpg";